// "use client";

// import { zero_pad_number } from "@core/helpers/string";
// import { useEffect, useState } from "react";

// const useCountDown = ({ number, countdown_className } = {}) => {
// 	const [seconds, set_seconds] = useState(number);

// 	const convert_countdown_time = (time, formats = ["minutes", "seconds"]) => {
// 		const month_format = zero_pad_number(parseInt((time / 60 / 60 / 24 / 30) % 12));
// 		const days_format = zero_pad_number(parseInt((time / 60 / 60 / 24) % 30));
// 		const hours_format = zero_pad_number(parseInt((time / 60 / 60) % 24));
// 		const minutes_format = zero_pad_number(parseInt((time / 60) % 60));
// 		const seconds_format = zero_pad_number(time % 60);

// 		return (
// 			<div className={`${countdown_className || ""}`}>
// 				{formats?.includes("months") && <span className="timer days">{month_format}</span>}
// 				{formats?.includes("months") ? <span className="time-divider">:</span> : ''}

// 				{formats?.includes("days") && <span className="timer days">{days_format}</span>}
// 				{formats?.includes("days") ? <span className="time-divider">:</span> : ''}

// 				{formats?.includes("hours") && <span className="timer hours"> {hours_format}</span>}
// 				{formats?.includes("hours") ? <span className="time-divider">:</span> : ''}

// 				{formats?.includes("minutes") && <span className="timer minutes">{minutes_format}</span>}
// 				{formats?.includes("minutes") ? <span className="time-divider">:</span> : ''}

// 				{formats?.includes("seconds") && <span className="timer seconds">{seconds_format}</span>}
// 			</div>
// 		);
// 	};

// 	useEffect(() => {
// 		const interval = setInterval(() => {
// 			if (!seconds || seconds <= 0) {
// 				clearInterval(interval);
// 			} else {
// 				set_seconds((prevSeconds) => prevSeconds - 1);
// 			}
// 		}, 1000);

// 		return () => clearInterval(interval);
// 	}, [seconds]);

// 	return {
// 		counter_down: seconds,
// 		set_counter_down: set_seconds,
// 		convert_countdown_time,
// 	};
// };

// export default useCountDown;


"use client";

import { zero_pad_number } from "@core/helpers/string";
import { useEffect, useState } from "react";
import { useBfcacheRestore } from "@core/helpers/client/bfcache";

const useCountDown = ({ number = 0, countdown_className } = {}) => {
	const [seconds, set_seconds] = useState(number);

	useEffect(() => {
		set_seconds(number || 0);
	}, [number]);

	// bfcache (all sites, asked by jument): timers do not tick while the page sits in the back/forward cache;
	// on restore the time it was frozen is taken off, so an offer or OTP timer shows the real time left
	useBfcacheRestore((event, { frozen_ms } = {}) => {
		const frozen_seconds = Math.floor((frozen_ms || 0) / 1000);
		if (frozen_seconds > 0) {
			set_seconds((prev) => Math.max(0, prev - frozen_seconds));
		}
	});

	const convert_countdown_time = (
		time,
		{
			formats = ["minutes", "seconds"],
			convertDaysToHours = false,
		} = {}
	) => {
		const totalSeconds = Math.max(0, parseInt(time || 0));

		const month_format = zero_pad_number(parseInt((totalSeconds / 60 / 60 / 24 / 30) % 12));
		const rawDays = parseInt(totalSeconds / 60 / 60 / 24);
		const rawHours = parseInt((totalSeconds / 60 / 60) % 24);
		const minutes_format = zero_pad_number(parseInt((totalSeconds / 60) % 60));
		const seconds_format = zero_pad_number(parseInt(totalSeconds % 60));

		const finalHours = convertDaysToHours
			? zero_pad_number((rawDays * 24) + rawHours)
			: zero_pad_number(rawHours);

		const days_format = zero_pad_number(rawDays);

		const visibleFormats = [...formats];

		if (convertDaysToHours) {
			const dayIndex = visibleFormats.indexOf("days");
			if (dayIndex !== -1) {
				visibleFormats.splice(dayIndex, 1);
			}
		}

		const values = {
			months: month_format,
			days: days_format,
			hours: finalHours,
			minutes: minutes_format,
			seconds: seconds_format,
		};

		return (
			<div className={`${countdown_className || ""}`}>
				{visibleFormats.map((format, index) => (
					<span key={format}>
						<span className={`timer ${format}`}>{values[format]}</span>
						{index < visibleFormats.length - 1 && (
							<span className="time-divider">:</span>
						)}
					</span>
				))}
			</div>
		);
	};

	useEffect(() => {
		if (seconds <= 0) return;

		const interval = setInterval(() => {
			set_seconds((prevSeconds) => {
				if (prevSeconds <= 1) {
					clearInterval(interval);
					return 0;
				}
				return prevSeconds - 1;
			});
		}, 1000);

		return () => clearInterval(interval);
	}, [seconds]);

	return {
		counter_down: seconds,
		set_counter_down: set_seconds,
		convert_countdown_time,
	};
};

export default useCountDown;

